/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Stream_ReloadInputs */

const vi_grower_area_camera_stream_reload = /** @type {(inputs: Grower_Area_Camera_Stream_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tải lại khung hình`)
};

/**

* @param {Grower_Area_Camera_Stream_ReloadInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_stream_reload = /** @type {((inputs?: Grower_Area_Camera_Stream_ReloadInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Stream_ReloadInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_stream_reload(inputs)
});